import { createMuiTheme } from '@material-ui/core';
import shadows from './shadows';

const MuiTheme = createMuiTheme({
  palette: {
    primary: {
      main: '#395b77'
    },
    grey: {
      300: '#f7f8f9',
      A100: '#e6e7e7'
    },
    blue: {
      main: '#2371ed'
    },
    secondary: {
      main: '#4191ff'
    },
    error: {
      main: '#f83245'
    },
    success: {
      main: '#1bc943'
    },
    info: {
      main: '#11c5db'
    },
    warning: {
      main: '#f4772e'
    },
    helpers: {
      primary: '#3c44b1',
      main: 'rgba(25, 46, 91, .035)'
    },
    contrastThreshold: 3,
    tonalOffset: 0.1
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 576,
      md: 768,
      lg: 1100,
      xl: 1381
    }
  },
  shape: {
    borderRadius: '0.2rem'
  },
  overrides: {
    root: {
      fontSize: 12
    },
    MuiCheckbox: {
      root: {
        padding: '9px 3px',
        fontSize: 12
      }
    },
    MuiTextField: {
      root: {
        fontSize: 12
      }
    },
    MuiAutocomplete: {
      root: {
        fontSize: 12
      },
      option: {
        fontSize: 12
      }
    },
    MuiInputBase: {
      root: {
        fontSize: 12
      }
    },
    MuiFormControlLabel: {
      root: {
        fontSize: 12
      }
    },
    MuiFormLabel: {
      root: {
        fontSize: 12
      }
    },
    MuiSelect: {
      root: {
        fontSize: 12
      }
    },
    MuiMenuItem: {
      root: {
        fontSize: 12
      }
    },
    MuiPagination: {
      root: {
        fontSize: 12
      }
    },
    MuiPaginationItem: {
      root: {
        fontSize: 12
      }
    },
    MuiTab: {
      root: {
        fontWeight: 'bold'
      }
    },
    MuiButton: {
      sizeSmall: {
        padding: '6px 20px',
        fontSize: 12
      },
      outlinedSmall: {
        padding: '6px 20px',
        fontSize: 12
      },
      textSmall: {
        padding: '6px 20px',
        fontSize: 12
      },

      sizeMedium: {
        padding: '10px 22px',
        fontSize: 11
      },
      outlined: {
        padding: '10px 22px',
        fontSize: 12
      },
      text: {
        padding: '10px 22px',
        fontSize: 12
      },

      sizeLarge: {
        padding: '16px 28px',
        fontSize: 14
      },
      outlinedLarge: {
        padding: '16px 28px',
        fontSize: 14
      },
      textLarge: {
        padding: '16px 28px',
        fontSize: 14
      },

      root: {
        textTransform: 'none',
        fontWeight: 'normal',
        padding: '10px 22px',
        fontSize: 12
      }
    },
    MuiTooltip: {
      tooltip: {
        backgroundColor: '#070919',
        padding: '8px 16px',
        fontSize: '13px'
      },
      arrow: {
        color: '#070919'
      }
    },
    MuiTypography: {
      root: {
        fontSize: 12
      },
      body1: {
        fontSize: 12
      },
      body2: {
        fontSize: 12
      }
    }
  },
  typography: {
    fontFamily: ['Heebo', 'sans-serif'].join(','),
    htmlFontSize: 14,
    fontSize: 12
  },
  shadows
});

export default MuiTheme;
